import { render } from "./LoaderComponent.vue?vue&type=template&id=410bd653&scoped=true"
const script = {}

import "./LoaderComponent.vue?vue&type=style&index=0&id=410bd653&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410bd653"]])

export default __exports__